import { Action } from '@/_core/fluxstore/types';
import { CurrentWsState } from '../types';
import { useCurrentWsStore } from '../useModule';

const { registerReducer } = useCurrentWsStore();

export class InitCurrentWs extends Action<CurrentWsState> {
    public static ACTION_TYPE = 'InitCurrentWs';
    public constructor() {
        super(InitCurrentWs.ACTION_TYPE);
    }
}

// eslint-disable-next-line
const reducer = (state: CurrentWsState, action: InitCurrentWs): void => {
    state.hasCurrentWs = initAppData.isInWsContext;
    state.name = initAppData.currentWs?.name;
    state.memberCount = initAppData.currentWs?.memberCount;
    state.observerCount = initAppData.currentWs?.observerCount;
};

//@ts-ignore
registerReducer(InitCurrentWs.ACTION_TYPE, reducer);